import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { UtilsService } from './utils.service';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code'];

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private translate = inject(TranslateService);
  private httpClient = inject(HttpClient);
  private utilsService = inject(UtilsService);

  init(): void {
    this.translate.addLangs(SUPPORTED_LANGUAGES.map((l) => l.code));
  }

  /** Called after login — sets the active language from the user's profile. */
  applyUserLanguage(language: string | undefined): void {
    const lang = this.isSupportedLanguage(language) ? language : 'en';
    this.translate.use(lang);
  }

  get currentLang(): string {
    return this.translate.currentLang() ?? 'en';
  }

  setLanguage(code: LanguageCode): Observable<unknown> {
    this.translate.use(code);
    return this.httpClient
      .patch(this.utilsService.buildApiUrl('users/me/'), { language: code });
  }

  private isSupportedLanguage(lang: string | undefined): lang is LanguageCode {
    return SUPPORTED_LANGUAGES.some((l) => l.code === lang);
  }
}
